import type { CSSProperties } from 'react';

/** Golden-angle packing: neighbors stay far apart for any cart size. */
const POS_GOLDEN_ANGLE = 137.507764;

export type PosItemTint = {
  h: number;
  s: number;
  bgL: number;
  fgL: number;
};

function tintFromSeed(seed: number): PosItemTint {
  const n = Math.abs(Math.floor(seed));
  const h = (n * POS_GOLDEN_ANGLE) % 360;
  const satBand = n % 5;
  const lightBand = Math.floor(n / 5) % 4;
  return {
    h,
    s: 50 + satBand * 8,
    bgL: 94.6 + lightBand * 0.9,
    fgL: 38 + (satBand % 3) * 5,
  };
}

export function getCartLineTint(index: number): PosItemTint {
  return tintFromSeed(index + 1);
}

export function posItemTintStyle(tint: PosItemTint): CSSProperties {
  return {
    ['--pos-item-h' as string]: tint.h.toFixed(2),
    ['--pos-item-s' as string]: `${tint.s}%`,
    ['--pos-item-bg-l' as string]: `${tint.bgL}%`,
    ['--pos-item-fg-l' as string]: `${tint.fgL}%`,
  };
}
